




















































































































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { FileCompactViewModel } from '@/views/Group/TopPage/SharedFolder/Layout/SharedFolderLayout.vue'
import { EFileFormat, EUserStatus } from '@/models'
import CheckFileFormat from '@/helpers/CheckFileExtension'
import FormatDate from '@/helpers/FormatDate'
import GroupSharedFolderService from '@/services/GroupSharedFolderService'
import CommonSharedFolderService from '@/services/CommonSharedFolderService'
//@ts-ignore
import _ from 'lodash'

import { getModule } from 'vuex-module-decorators'
import CommonTopic from '@/store/modules/CommonTopic'
import store from '@/store'
import { hanldeUserStatus } from '@/helpers/Common'
import UserInfo from "@/store/modules/UserInfo";

const CommonTopicModule = getModule(CommonTopic, store)
const UserModule = getModule(UserInfo, store)

@Component
export default class SharedFolderList extends Vue {
  @Prop() files!: FileCompactViewModel[]
  @Prop() startLoading!: boolean
  @Prop() disableCheckbox?: boolean
  @Prop() forGroupTop?: boolean
  @Prop() isFromHome?: boolean
  @Prop() isHomeCommon?: boolean
  @Prop() private groupId?: string
  private isCommonTopic = !this.$route.params.groupId
  eFileFormat = EFileFormat

  isDisableCheckbox(item: FileCompactViewModel) {
    const checkedItem = this.files.find(t => t.checked)

    if (!checkedItem) {
      return false
    }

    return Boolean(item.is_pin) !== Boolean(checkedItem.is_pin)
  }

  handleCheckItem() {
    const hasAnyChecked = this.files.some(item => item.checked)

    const unpinFiles = this.files.filter(item => !item.is_pin)
    const pinFiles = this.files.filter(item => item.is_pin)

    const allUnpinChecked =
      unpinFiles.length > 0 && unpinFiles.every(item => item.checked)

    const allPinChecked =
      pinFiles.length > 0 && pinFiles.every(item => item.checked)

    if (allUnpinChecked || allPinChecked) {
      this.$emit('addCheckAll')
    } else {
      this.$emit('removeCheckAll')
    }

    this.$emit('selectAnyItem', hasAnyChecked)
  }

  async handleMarkRead(index: number) {
    this.$blockui.show()
    if ((this.isCommonTopic && !this.isFromHome) || this.isHomeCommon) {
      CommonSharedFolderService.markCommonFileAsRead(this.files[index].id)
        .then(res => {
          if (res.status === 200) {
            this.files[index].is_read = true
            this.$emit('subtractReadCount')
            //handle rebind unred count
            CommonTopicModule.SET_RELOAD_UNREAD(true)
          }
        })
        .catch(err => {
          // this.$bvModal.show('modal-error-shared-folder-list')
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupSharedFolderService.markFileAsRead(
        this.isFromHome ? String(this.groupId) : this.$route.params.groupId,
        this.files[index].id
      )
        .then(res => {
          if (res.status === 200) {
            this.files[index].is_read = true
            this.$emit('subtractReadCount')
            //handle rebind unred count
            CommonTopicModule.SET_RELOAD_UNREAD(true)
          }
        })
        .catch(err => {
          // this.$bvModal.show('modal-error-shared-folder-list')
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Handle jumping to topic detail page
   */
  jumpToFileDetailPage(index: number, push?: boolean) {
    const fileId = this.files[index].id
    let route: any
    if ((this.isCommonTopic && !this.isFromHome) || this.isHomeCommon) {
      route = {
        name: 'common-topic-shared-folder-file-detail',
        params: { fileId: String(fileId), from: this.$route.path }
      }
    } else {
      route = {
        name: 'group-shared-folder-file-detail',
        params: {
          fileId: String(fileId),
          groupId: this.isFromHome
            ? String(this.groupId)
            : this.$route.params.groupId,
          folder: this.$route.query.folder
            ? String(this.$route.query.folder)
            : '',
          from: this.$route.path
        }
      }
    }
    if (push) {
      this.$router.push(route)
    } else {
      return route
    }
  }

  getFileFormat(fileExtension: string) {
    return CheckFileFormat.getFileFormat(fileExtension)
  }

  getIconName(fileExtension: string) {
    return CheckFileFormat.getIconClassName(
      CheckFileFormat.getFileFormat(fileExtension)
    )
  }

  formatDateWithDays(date: string) {
    return FormatDate.formatDateWithDays(date)
  }

  handleLongText(text: string) {
    return _.truncate(text, {
      length: 50,
      separator: ' '
    })
  }

  handleUpdaterName(file: FileCompactViewModel) {
    let text = hanldeUserStatus(
      file.updater?.name,
      file.user_active_status
    )
    return {
      name: text,
      text: _.truncate(text, {
        length: 20,
        separator: ' '
      })
    }
  }

  async togglePinFile(file: FileCompactViewModel, index: number) {
    if (!this.forGroupTop) {
      if (!file.is_pin) {
        await this.handleMarkRead(index)
      }
      this.$emit('togglePinFile', file)
    }
  }
}
